import type { BackgroundColors } from '../../schema/schema-util'

const colorMap: Record<BackgroundColors, { className: string; darkBg: boolean }> = {
  primary: { className: 'bg-primary text-white', darkBg: true },
  aubergine: { className: 'bg-aubergine text-white', darkBg: true },
  ocker: { className: 'bg-ocker text-primary', darkBg: true },
  lightblue: { className: 'bg-lightblue text-primary', darkBg: false },
  rose: { className: 'bg-rose text-primary', darkBg: false },
  sand: { className: 'bg-sand text-primary', darkBg: false },
  lightgreen: { className: 'bg-lightgreen text-primary', darkBg: false },
}

export function textAndBackgroundColor(backgroundColor?: BackgroundColors) {
  if (!backgroundColor) return ''
  return colorMap[backgroundColor]?.className || ''
}

export function isDarkBg(backgroundColor?: BackgroundColors) {
  if (!backgroundColor) return false
  return colorMap[backgroundColor]?.darkBg || false
}
